import AniNav from '../../Components/AniNav';
import './Charities.css';
function Charities()
{
   
    return(
        <div className = "charities">
            <AniNav />

          
            <h1 className = "comingsoon" >
            </h1>
        </div>
    )
}

export default Charities;